
import Netflix from '../assets/portfolio/netflix.png'
import  QrCode  from '../assets/portfolio/Screenshot.png';
import Pinterest from '../assets/portfolio/pinterest.png';
import RandomPassword from '../assets/portfolio/random-password.png'
export const Data = [
    {
        title:"Netflix",
        img:Netflix,
        text:"Projeto desenvolvi usando uma api durante o curso",
        link:"https://web-matheus.github.io/netflix/index.html"
    },
    {
        title:"Qr-code",
        img:QrCode,
        text:"Um site onde o usuário pode criar seu próprio qr-code",
        link:"https://qr-codejs.netlify.app/"
    },
    {
        title:"Pinterest-clone",
        img:Pinterest,
        text:"Clone do pinterest desenvolvido com react,tailwind para estilização",
        link:"https://pinterest-gallery.netlify.app/"
    },
    {
        title:"Gerador de senha",
        img:RandomPassword,
        text:"Esse projeto foi uma desafio do frontend mentor, cujo o objetivo é o usuário poder gerar senha de forma aleátoria, com caracteres, números e letras",
        link:"https://random-password-secret.netlify.app/"
    }
]